import Sortable from 'sortablejs';

$(() => {
  if (!$('#owner-special_categories_index').length) {
    return
  }

  const tbody = document.querySelector(".js-special-categories tbody");
  const idsInput = document.getElementById("js-special-categories-ids");
  const form = document.getElementById("js-special-categories-form");

  if (tbody && idsInput && form) {
    Sortable.create(tbody, {
      animation: 150,
      handle: ".js-sortable-col",   // ← ドラッグするハンドル要素を制限したい場合
    });

    form.addEventListener("submit", () => {
      const ids = Array.from(tbody.querySelectorAll("tr"))
        .map(tr => tr.dataset.id);
      idsInput.value = ids.join(",");
    });
  }
})